import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { customerInterface, permissionsInterface } from 'src/app/util/interfaces/customer';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { groupInterface } from 'src/app/util/interfaces/group';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class CustomerInformationService {
	private customerInformationUrl = environment.baseApiUrl + 'register/form/customer';
	private customerDataUrl = environment.baseApiUrl + 'customer/{idCustomer}';
	private getContractedSolutionAreasUrl = environment.baseApiUrl + 'register/contractedSolutionAreas';
	private updateContractedSolutionAreasUrl = environment.baseApiUrl + 'register/contractedSolutionAreas';

	private customerPermissionUrl = environment.baseApiUrl + 'register/customer/permission';

	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	constructor(
		private AuthLoginService: AuthLoginService,
		private http: HttpClient
	) {}

	getCustomerForm(): Observable<genericFormInterface[]> {
		return this.http.get<genericFormInterface[]>(this.customerInformationUrl, { headers: this.headers });
	}

	getCustomerData(idCustomer: string): Observable<customerInterface> {
		const customerDataUrl = this.customerDataUrl.replace('{idCustomer}', idCustomer);
		return this.http.get<customerInterface>(customerDataUrl, { headers: this.headers });
	}

	updateCustomer(body: any): Observable<any> {
		const customerDataUrl = this.customerDataUrl.replace('{idCustomer}', body.id);
		return this.http.put<any>(customerDataUrl, body, { headers: this.headers });
	}

	getContractedSolutionAreas(): Observable<groupInterface[]> {
		return this.http.get<groupInterface[]>(this.getContractedSolutionAreasUrl, { headers: this.headers });
	}

	updateContractedSolutionAreas(body: any): Observable<any> {
		return this.http.put<any>(this.updateContractedSolutionAreasUrl, body, { headers: this.headers });
	}

	getCustomerPermissions(): Observable<permissionsInterface[]> {
		return this.http.get<any>(this.customerPermissionUrl, { headers: this.headers });
	}

	updateCustomerServices(allowedPermissions: permissionsInterface[]): Observable<any> {
		return this.http.put(this.customerPermissionUrl, allowedPermissions, { headers: this.headers });
	}
}
